/* Sol Calypso - Exclusives collage. */
(function () {
  function init(root) {
    if (root.dataset.scReady) return;
    root.dataset.scReady = '1';

    var keyed = root.querySelectorAll('[data-sc-key]');
    function setActive(key, on) {
      for (var i = 0; i < keyed.length; i++) {
        if (keyed[i].getAttribute('data-sc-key') === key) keyed[i].classList.toggle('is-active', on);
      }
    }
    root.querySelectorAll('.sc-ex__row[data-sc-key], .sc-ex__shot[data-sc-key]').forEach(function (el) {
      var key = el.getAttribute('data-sc-key');
      if (!key) return;
      el.addEventListener('mouseenter', function () { setActive(key, true); });
      el.addEventListener('mouseleave', function () { setActive(key, false); });
      el.addEventListener('focusin', function () { setActive(key, true); });
      el.addEventListener('focusout', function () { setActive(key, false); });
    });

    var stageBox = root.querySelector('.sc-ex__stage');
    var shots = root.querySelector('.sc-ex__shots');
    var shotEls = root.querySelectorAll('.sc-ex__shot');
    var idxWrap = root.querySelector('.sc-ex__index');
    var idxCard = root.querySelector('.sc-ex__index-inner');

    var wide = false;
    var travelPx = 0;
    var stickyTop = 120;

    function measure() {
      if (!shots || !shotEls.length || !stageBox) return;
      wide = window.matchMedia('(min-width: 750px)').matches;
      var cs = getComputedStyle(root);

      // On mobile the card stacks under the products instead of beside them, so
      // the box has to actually contain them or it lands on top of the tees. A
      // shot sits at top:t% of this box but takes its height from the box WIDTH,
      // so the height that contains it is overhang / (1 - t). Solved per shot and
      // capped, in case a shot is parked near the very bottom. Because every
      // overhang scales with the width, the result scales with the phone: that is
      // what keeps the spacing looking the same on a small handset and a big one,
      // where a fixed pixel height drifts.
      if (!wide) {
        var floorH = num(cs.getPropertyValue('--sc-stage-hm'), 880);
        shots.style.minHeight = '';
        var box = shots.getBoundingClientRect();
        var need = floorH;
        for (var j = 0; j < shotEls.length; j++) {
          var el = shotEls[j];
          var t = num(getComputedStyle(el).getPropertyValue('--tm'), 0) / 100;
          if (!(t >= 0) || t >= 1) continue;
          var over = el.getBoundingClientRect().bottom - box.top - t * box.height;
          var want = over / (1 - t);
          if (want > need) need = want;
        }
        if (need > floorH * 3) need = floorH * 3;
        shots.style.minHeight = Math.ceil(need) + 'px';
      } else {
        shots.style.minHeight = '';
      }

      var sr = shots.getBoundingClientRect();
      var low = 0;
      for (var i = 0; i < shotEls.length; i++) {
        var b = shotEls[i].getBoundingClientRect().bottom - sr.top;
        if (b > low) low = b;
      }
      var lowest = sr.top + low;

      // The card is pinned here rather than with position:sticky. This theme does
      // not scroll the window: the page lives inside div.page-wrapper, which the
      // theme's own stylesheet gives overflow:auto. Driving the offset ourselves
      // works whatever element turns out to be doing the scrolling.
      if (idxCard) {
        idxCard.style.position = 'static';
        if (!wide) {
          travelPx = 0;
          idxCard.style.transform = '';
          root.style.setProperty('--sc-travel', '0px');
        } else {
          stickyTop = num(cs.getPropertyValue('--sc-sticky'), 0);
          var pct = num(cs.getPropertyValue('--sc-pin'), 100);
          if (!(pct >= 0)) pct = 100;
          var reach = Math.max(sr.height, low);
          travelPx = Math.max(0, Math.floor(reach * (pct / 100) - idxCard.getBoundingClientRect().height));
          root.style.setProperty('--sc-travel', travelPx + 'px');
        }
      }

      // Whatever still hangs below becomes bottom padding, so the section after
      // this one starts under the last tee instead of across it. On desktop the
      // reference is the stage box, which has already grown with the card's
      // reserved room; measuring against the shots box there counted the same
      // room twice. On mobile the box above now fits its own shots, so this is
      // normally zero and no longer leaves a dead gap under the card.
      var floorEdge = wide ? stageBox.getBoundingClientRect().bottom : sr.bottom;
      root.style.setProperty('--sc-spill', Math.max(0, Math.ceil(lowest - floorEdge)) + 'px');
    }

    function num(v, fallback) {
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    // Runs straight from the scroll event, not from an animation frame. Frame
    // callbacks are throttled to nothing while the tab is in the background, and
    // the card would then stay wherever it was left.
    function pinTick() {
      if (!idxCard || !idxWrap) return;
      if (!wide || travelPx <= 0) { idxCard.style.transform = ''; return; }
      var off = stickyTop - idxWrap.getBoundingClientRect().top;
      if (off < 0) off = 0;
      if (off > travelPx) off = travelPx;
      idxCard.style.transform = 'translate3d(0,' + Math.round(off) + 'px,0)';
    }

    function relayout() { measure(); pinTick(); }

    relayout();
    window.addEventListener('resize', relayout);
    window.addEventListener('orientationchange', relayout);
    window.addEventListener('load', relayout);
    root.querySelectorAll('.sc-ex__shot img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', relayout);
    });

    var strip = root.querySelector('[data-sc-strip]');
    var track = root.querySelector('[data-sc-track]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slide = !!(strip && track) && !still;
    var move = slide ? (num(root.dataset.travel, 100)) / 100 : 0;

    var ticking = false;
    function stripFrame() {
      ticking = false;
      if (!slide) return;
      var r = strip.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = (vh - r.top) / (r.height + vh);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var max = Math.max(0, track.scrollWidth - strip.clientWidth);
      track.style.setProperty('--sc-shift', (p * max * move).toFixed(1));
    }

    function onScroll() {
      pinTick();
      if (!slide) return;
      if (!ticking) { ticking = true; requestAnimationFrame(stripFrame); }
    }

    stripFrame();
    // Capture catches the scroll wherever it happens, including inside the
    // theme's page-wrapper, which is the element that actually scrolls.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
  }

  function boot() {
    document.querySelectorAll('.sc-ex').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
